$( function() {
	initLightbox();
});

function initLightbox() {
	$('.lightbox-trigger').on( "click", function(e) {
		e.preventDefault();
		$('html,body').addClass('noscroll');
		$(this).parent('.cta').next('.hidden-lightbox').find('.lightbox-wrap').clone().appendTo('.columns-text-with-ctas .lightbox');
		$(this).parents('.columns-text-with-ctas').find('.lightbox').show().addClass('active');
		activeLightbox();
	});
}

function activeLightbox() {
	$('.columns-text-with-ctas .lightbox').on('click', function(e) {
		if (e.target !== this) return;
		$('.lightbox.active').fadeOut(300).removeClass('active');
		$('html,body').removeClass('noscroll');
		$('.lightbox').find('.lightbox-wrap').remove();
	});
	$(document).on('keydown', function(e) {
		if (e.key == "Escape") {
			$('.lightbox.active').fadeOut(300).removeClass('active');
			$('html,body').removeClass('noscroll');
			$('.lightbox').find('.lightbox-wrap').remove();
		}
	});
	$('body').on('click', '.lightbox .close-btn', function(e) {
		e.preventDefault();
		$('.lightbox.active').fadeOut('fast').removeClass('active');
		$('html,body').removeClass('noscroll');
		$('.lightbox').find('.lightbox-wrap').remove();
	});
}